<template>
  <div id="main-page">

     <v-dialog v-model="showGrade" max-width="900px" attach="#main-page" >
        <view-grade
            v-if="showGrade "
            :graded_lead="selectedLead"
            @close-parent="showGrade=false"
        ></view-grade>
     </v-dialog>




     <v-dialog v-model="editGrade" max-width="1200px" persistent >
        <div style="background-color: white">
           <div style="justify-content: flex-end; display: flex; margin-bottom: -20px">
              <v-btn icon @click="close_edit_dialog()">
                 <v-icon>close</v-icon>
              </v-btn>
           </div>
           <edit-grade
               v-if=" editGrade"
               :grade_id="selectedLead._id"
               @close="close_edit_dialog()"

           />
        </div>

     </v-dialog>





     <v-dialog
         v-model="dialog_delete_grade"
         max-width="420"
     >
        <v-card>
           <v-card-title class="headline">Confirm Delete Grade?</v-card-title>

           <v-card-text>
              Are you sure you want to delete this graded lead?
           </v-card-text>

           <v-card-actions>
              <v-btn color="red" text @click="delete_graded_lead(del_grade_id)">Delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn text @click="close_del_confirm">Cancel</v-btn>
           </v-card-actions>
        </v-card>
     </v-dialog>











    <section-definition :title="page.title" ></section-definition>

    <v-container fluid grid-list-xl page>
      <v-layout row wrap>
        <v-flex grow></v-flex>



        <v-flex xs4 sm4 md2>
          <v-menu
              v-model="date_menu1"
              :close-on-content-click="false"
              :nudge-right="0"
              lazy
              transition="scale-transition"
              offset-y
              :nudge-bottom="0"
              full-width
              max-width="290px"
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_begin"
                      label="Begin Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"
                      v-on:change="on_change_top_inputs"
              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_begin"
                    no-title
                    @input="date_menu1 = false"
                    v-on:change="on_change_top_inputs"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs4 sm4 md2>
          <v-menu
                  v-model="date_menu2"
                  :close-on-content-click="false"
                  :nudge-right="0"
                  lazy
                  transition="scale-transition"
                  offset-y
                  :nudge-bottom="0"
                  full-width
                  max-width="290px"
                  min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_end"
                      label="End Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_end"
                    no-title
                    @input="date_menu2 = false"
                    v-on:change="on_select_dealership"
            ></v-date-picker>
          </v-menu>
        </v-flex>


         <v-flex xs12 sm4 md2>

            <v-autocomplete
                label="Organization"
                :items="orgs"
                item-value="_id"
                item-text="name"
                v-model="selected_org_id"
                v-on:change="on_org_change"
            >
            </v-autocomplete>

         </v-flex>


         <v-flex xs12 sm6 md3>

            <v-autocomplete
                label="Dealership"
                :items="dealerships"
                item-value="_id"
                item-text="name"
                v-model="selectedDealership"
                v-on:change="on_select_dealership"
                clearable
            >
            </v-autocomplete>

         </v-flex>

        <!-- -->
        <!--<v-flex xs12 sm6 md4>-->

        <!--  <v-autocomplete-->
        <!--          label="Organization/Dealership"-->
        <!--          :items="dealerships"-->
        <!--          item-value="_id"-->
        <!--          item-text="txt"-->
        <!--          v-model="selectedDealership"-->
        <!--          v-on:change="on_select_dealership"-->
        <!--  >-->
        <!--  </v-autocomplete>-->

        <!--</v-flex>-->
      </v-layout>


      <v-container fluid grid-list-md page>
        <v-layout>

          <!----------------------------------------card for overall dealer grade-------------------------------->
          <v-flex xs12 sm4 v-if="!sp_mode">
            <v-card>
              <v-toolbar color="transparent" flat>
                <v-toolbar-title>{{overall_grade_card_txt}}</v-toolbar-title>
                <!--<v-spacer></v-spacer>-->
                <!--<v-btn icon>-->
                  <!--<v-icon>more_horiz</v-icon>-->
                <!--</v-btn>-->
              </v-toolbar>
              <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
              <v-card-text class="text-xs-center">
                <v-progress-circular
                        :rotate="0"
                        :value="100"
                        :size="240"
                        :width="15"
                        :color="get_grade_color(gradeIxToLetter(grade_dealership.avg_grade_ix))"
                >
                  <span class="grade-card"><strong>{{gradeIxToLetter(grade_dealership.avg_grade_ix)}}</strong> </span><br>
                  <span class="grey--text">Average Grade</span>
                </v-progress-circular>
                <div class="title my-2">Date Range</div>
                <span class="subheading grey--text">{{selected_date_begin}} to {{selected_date_end}}</span>
              </v-card-text>
            </v-card>
          </v-flex>


          <!---------------------------card to list average grade of sales people------------------------->
          <v-flex xs12 sm8 v-if="!sp_mode">
            <v-card max-height="396px" style="overflow: auto">
              <v-toolbar color="transparent" flat>
                <v-toolbar-title>Sales Person Ranking</v-toolbar-title>
              </v-toolbar>
              <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
              <v-card-text class="text-xs-left">

                <v-data-table
                        :headers="sp_headers"
                        :items="grades_salesPeople"
                        :pagination.sync="sp_pagination"
                        hide-actions



                >
                  <template slot="items" slot-scope="props" >
                    <tr
                      class="row_style"
                      style="cursor:pointer;"
                      @click="on_select_salesPerson(props.item)"
                      :key="props.item.user_id+props.item.dealership+props.item.curriculum._id"
                    >
                      <!--<td class="my-col">-->
                      <!--  <v-avatar slot="activator" size="40">-->
                      <!--    <img-->
                      <!--        v-if="props.item.picture !== ''"-->
                      <!--        :src="props.item.picture">-->
                      <!--  </v-avatar>-->
                      <!--</td>-->
                      <td class="my-col">{{ props.item.name }}</td>
                       <td class="my-col">{{ props.item.dealership }}</td>
                      <td class="my-col ">{{ get_val(props.item, 'curriculum.name', 'N/A')}}</td>
                      <td class="my-col txt-center">{{ gradeIxToLetter(props.item.avg_grade_ix)}}</td>
                      <!--<td>{{ props.item.avg_score }}</td>-->
                      <td class="my-col txt-center">{{ props.item.count }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>





        </v-layout>



        <!------------------------------list of individual graded leads------------------------------------------------>
        <v-layout v-if="show_graded_leads">
          <v-flex xs12>
            <v-card>
              <v-toolbar color="transparent" flat>
                <v-toolbar-title>Graded Leads For: {{selectedSalesPerson ? selectedSalesPerson.name : ''}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon>more_horiz</v-icon>
                </v-btn>
              </v-toolbar>
              <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
              <v-card-text class="text-xs-left">

                <v-data-table
                    :headers="gl_headers"
                    :items="sp_graded_leads"
                >
                  <template slot="items" slot-scope="props" >
                    <tr  v-on:click="view_this_grade(props.item)" style="cursor:pointer;"
                         :style="is_draft(props.item)? 'background-color:yellow':''">
                      <td style="white-space: nowrap">{{ props.item.info_lead.lead_arrived_date.slice(0, 10) }}</td>
                      <td style="white-space: nowrap">{{ props.item.date_graded.slice(0, 10) }}</td>
                      <td class="txt-center">{{ props.item.curriculum.name }}</td>
                      <td class="txt-center">{{ props.item.grade_letter }}</td>
                      <td class="txt-center">{{ round(props.item.grade_score, 1) }}</td>
                      <td>{{ props.item.info_customer.name_first +' ' + props.item.info_customer.name_last}}</td>
                      <td>{{ props.item.info_lead.wanted_vehicle }}</td>
                      <td>{{ truncate_str(props.item.comments_external) }}</td>
                      <td v-if="gl_headers.length === 9"><!-- header based on user type-->
                         <div style="display: flex; ">
                            <v-icon small color="primary" @click.stop="edit_this_grade(props.item)">edit</v-icon>

                            <v-icon small color="error" @click.stop="del_grade(props.item)" v-if="isAdmin">
                               delete
                            </v-icon>
                         </div>

                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
              </v-card>

          </v-flex>

        </v-layout>







      </v-container> <!--main container-->
    </v-container>











  </div>
</template>


<style scoped>
  .grade-card{
    font-size: xx-large;
    font-weight: bolder;
    /*color: black;*/
  }

  .row_style{
    text-align: left;
    border: none !important;
    font-size: large;
  }

  .txt-center{
      text-align: center;
  }

 div >>> td{
      padding-left: 7px !important;
      padding-right: 7px !important;
  }

  div >>> th{
      padding-left: 7px !important;
      padding-right: 7px !important;
  }
</style>


<script>
   import axios from 'axios';
   const moment = require('moment');
   import viewGrade from '../components/viewGrade.vue';
   import editGrade from "@/views/Curricula/GradeLead";
   import data_getters from '../mixins/data_getters';
   import _ from 'lodash';

   import {DateTime} from 'luxon';

   // function findWithAttr(array, attr, value) {
   //    for(var i = 0; i < array.length; i += 1) {
   //       if(array[i][attr] === value) {
   //          return i;
   //       }
   //    }
   //    return -1;
   // }



export default {
      name: 'GradeReport',
   components:{
      viewGrade, editGrade
   },

   mixins: [data_getters],

  data() {
     return {
        letter_grades: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'],
        date_menu1: false,
        date_menu2: false,
        selected_date_begin:   moment().subtract(30, 'days').format('YYYY-MM-DD'),
        selected_date_end:   moment().format('YYYY-MM-DD'),

        orgs: [],
        selected_org_id: null,

        dealerships: [],
        selectedDealership: null,
        salesPeople: [],
        selectedSalesPerson: null,

        grade_dealership: {},
        grades_salesPeople: [],
        sp_graded_leads: [],

        selectedLead: null,
        showGrade: false,

        editGrade: false,

        // sp_headers: [
        //    // {text: '', value: 'picture', width: '5%'},
        //    {text: 'Sales Person', value: 'name', width: '25%'},
        //    {text: 'Dealership', value: 'dealership', width: '25%'},
        //    {text: 'Curriculum', value: 'curriculum.name', width: '20%'},
        //    {text: 'Avg Grade', value: 'avg_grade_ix', width: '10%'},
        //    // {text: 'Avg Score', value: 'avg_score', width: '20%'},
        //    {text: '# Leads', value: 'count', width: '10%'},
        // ],

        sp_headers: [
           // {text: '', value: 'picture', width: '5%'},
           {text: 'Sales Person', value: 'name',},
           {text: 'Dealership', value: 'dealership',},
           {text: 'Curriculum', value: 'curriculum.name', },
           {text: 'Avg Grade', value: 'avg_grade_ix', },
           // {text: 'Avg Score', value: 'avg_score', width: '20%'},
           {text: '# Leads', value: 'count', },
        ],

        sp_pagination: {
           sortBy: 'avg_grade_ix', // The field that you're sorting by
           descending: false,
           rowsPerPage: -1
        },


        // gl_headers_non_admin: [
        //    {text: 'Date In', value: 'info_lead.lead_arrived_date', width: '10%'},
        //    {text: 'Date Graded', value: 'date_graded', width: '10%'},
        //    {text: 'Curriculum', value: 'curriculum.name', width: '5%'},
        //    {text: 'Grade', value: 'grade_letter', width: '5%'},
        //    {text: 'Score', value: 'grade_score', width: '5%'},
        //    {text: 'Customer', value: 'count', width: '15%'},
        //    {text: 'Vehicle', value: 'info_lead.wanted_vehicle', width: '15%'},
        //    {text: 'Comments', value: 'comments_external', width: '45%'},
        // ],
        //
        // gl_headers_admin: [
        //    {text: 'Date In', value: 'info_lead.lead_arrived_date', width: '10%'},
        //    {text: 'Date Graded', value: 'date_graded', width: '10%'},
        //    {text: 'Curriculum', value: 'curriculum.name', width: '5%'},
        //    {text: 'Grade', value: 'grade_letter', width: '5%'},
        //    {text: 'Score', value: 'grade_score', width: '5%'},
        //    {text: 'Customer', value: 'count', width: '15%'},
        //    {text: 'Vehicle', value: 'info_lead.wanted_vehicle', width: '15%'},
        //    {text: 'Comments', value: 'comments_external', width: '45%'},
        //    {text: '', value: '', width: '5%'},
        //
        // ],



        gl_headers_non_admin: [
           {text: 'Date In', value: 'info_lead.lead_arrived_date', },
           {text: 'Date Graded', value: 'date_graded', },
           {text: 'Curriculum', value: 'curriculum.name', },
           {text: 'Grade', value: 'grade_letter', },
           {text: 'Score', value: 'grade_score', },
           {text: 'Customer', value: 'count', },
           {text: 'Vehicle', value: 'info_lead.wanted_vehicle', },
           {text: 'Comments', value: 'comments_external',},
        ],

        gl_headers_admin: [
           {text: 'Date In', value: 'info_lead.lead_arrived_date', },
           {text: 'Date Graded', value: 'date_graded', },
           {text: 'Curriculum', value: 'curriculum.name', },
           {text: 'Grade', value: 'grade_letter', },
           {text: 'Score', value: 'grade_score', },
           {text: 'Customer', value: 'count', },
           {text: 'Vehicle', value: 'info_lead.wanted_vehicle', },
           {text: 'Comments', value: 'comments_external', },
           {text: '', value: '',},

        ],


        dialog_delete_grade: false,
        del_grade_id: null,


        gl_pagination: {
           sortBy: 'avg_score', // The field that you're sorting by
           descending: true,
           rowsPerPage: -1
        },

        page: {
           title: "Report Card",
        },

     };
  },
  methods:{
     // truncate_str(txt){
     //    if (typeof txt == 'string'){
     //       if (txt.length > 100){
     //          txt = txt.slice(0, 100) + '...';
     //       }
     //    }
     //    return txt;
     // },


     //simple function to tell if a grade is a draft or not.  needed since we added the date_email field on 3/1/2021
     is_draft(lead) {

        // console.log({lead})
        // if (DateTime.fromISO(lead.date_graded) < DateTime.fromISO('2021-02-23T00:00:00')) {
        //    return false;
        // }

        return  (lead.emailed_users === null);
        // {
        //    return 'background-color: #ffffff';
        // } // note this needs to be an exact match to handle the case of date_emailed not being defined
     },


     get_val(obj, name, def=null){
        return _.get(obj, name, def)
     },


     async on_org_change(){
        this.selectedDealership = null;
        this.dealerships = await this.get_dealers({org_id: this.selected_org_id});
        await this.get_report_card();
     },



     async get_dealers_local(){


        try {
           // let {data} = await axios.get(url, token);
           this.dealerships = await this.get_dealers();

           for (let i=0; i<this.dealerships.length; i++){
              let d = this.dealerships[i];
              if (d.org_id){
                 this.dealerships[i].txt = d.org_id.name +' / '+d.name;
              }
              else{
                 this.dealerships[i].txt ='No Group/'+d.name;
              }
           }//for i

           this.dealerships = this.dealerships.sort((a, b) => (a.txt > b.txt) ? 1 : -1);


        }
        catch(err){
           console.log(err);
           // ans = err.response.data;
        }
     },



     on_change_top_inputs(){
       if (this.sp_mode){
          this.get_graded_leads_local(this.selectedSalesPerson.user_id)
       } else{
          this.on_select_dealership();
       }
     },


     async on_select_dealership(){


        console.log('debug')

        try{

           await this.get_report_card()

           if (this.$auth.profile.user_role === 'SalesPerson'){
              await this.get_graded_leads_local();
           }

        }catch (e) {
           console.error(e);
        }



     },


     async on_select_salesPerson(sp){
        this.selectedSalesPerson = sp;

        await this.get_graded_leads_local(sp.user_id)
     },

     view_this_grade(grade){
        this.selectedLead = grade;
        this.showGrade=true;


     },




     async delete_graded_lead( grade_id){
        console.log('grade', grade_id)
        let {token, query} = await this.base_user_request();
        let url = this.$baseUrlApi + '/deleteGradedLead';

        query.grade_id = grade_id;


        try {

           let res = await axios.post(url, {query }, token);
           this.dialog_delete_grade = false;
           this.del_grade_id = null;



           this.get_graded_leads_local(this.selectedSalesPerson.user_id)

        }
        catch(err){
           console.log(err);

        }
     },

     del_grade(grade){

        this.del_grade_id = grade._id;
        this.dialog_delete_grade = true;
     },

     close_del_confirm(){
        this.dialog_delete_grade = false;
        this.del_grade_id = null;
     },


     async get_graded_leads_local(user_id){

        if (user_id == null){
           user_id = this.selectedSalesPerson.user_id;
        }


        let dateRange = {begin: this.selected_date_begin, end: this.selected_date_end };

        console.log('debug')
        try {
           this.sp_graded_leads = await this.get_graded_leads({user_id, dateRange,
              dealer_id: this.selectedDealership == null? undefined: this.selectedDealership,
              org_id: this.selected_org_id, get_player_data: 'percent'});


           console.log('i ran')
        }
        catch(err){
           console.log(err);
           // ans = err.response.data;
        }
     },



     async get_report_card(){

        console.log('report_card')

        // if (this.selectedDealership === undefined)
        //    return;


        let {token, query} = await this.base_user_request();
        let url = this.$baseUrlApi + '/getReportCardData';




        let payload, payload2;
        if (this.selectedDealership){
           query.dealer_id = this.selectedDealership;

           payload = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              groupby: 'dealership',
              // user_role: 'SalesPerson',
           };

           payload2 = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              groupby: 'salesperson',
              // user_role: 'SalesPerson',
              sp_only_active: false,
              sp_groupby_all: true,
           };
        }


        else{
           delete query.dealer_id;
           query.org_id = this.selected_org_id;

           payload = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              groupby: 'organization',
              // user_role: 'SalesPerson',
           };

           payload2 = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              groupby: 'salesperson',
              // user_role: 'SalesPerson',
              sp_only_active: false,
              sp_groupby_all: true,
           };
        }


        console.log({payload, payload2, query})



        try {
           if (this.selectedDealership || true){
              let {data} = await axios.post(url, payload, token);

              if (data.length===1){
                 this.grade_dealership = data[0];
              }
              else{
                 this.grade_dealership = {avg_grade_ix: -1}
              }


              let res = await axios.post(url, payload2, token);
              this.grades_salesPeople = res.data;

           }

        }
        catch(err){
           console.log(err);
           this.avg_grade_ix = -1;

        }

     },





     gradeIxToLetter(ix){
        if (ix>-1){
           return this.letter_grades[Math.round(ix)];
        }
        else{
           return 'N/A';
        }
     },

     get_grade_color(grade){
        let ans;
        switch (grade.charAt(0)){
           case 'A':
              ans =  '#00C853';
              break;
           case 'B':
              ans =  '#F9A825';
              break;
           case 'C':
              ans =  '#F9A825';
              break;
           case 'D':
              ans =  '#D50000';
              break;
           case 'F':
              ans =  '#D50000';
              break;
           case 'N':
              ans =  '#9E9E9E';
              break;

        }
        return ans;
     },

     edit_this_grade(grade){
        this.selectedLead = grade;
        this.editGrade = true;


     },
     close_edit_dialog(){
        this.editGrade=false;
        this.selectedLead=null;
        this.get_graded_leads_local();
     }



  },
   computed: {
     sp_mode(){
        return this.$auth.profile.user_role === 'SalesPerson';
     },

      show_graded_leads(){
        if (this.$auth.profile.user_role !== 'SalesPerson'){
           return !!this.selectedSalesPerson;
        }
        else{
           return true;
        }

      },

      gl_headers(){

         // this.$auth.profile.user_role === 'Admin' &&
         if (this.$auth.profile.acct_type === 'AGENCY'){
            return this.gl_headers_admin;
         }
         else{
            return this.gl_headers_non_admin;
         }
      },

      overall_grade_card_txt(){
        if (this.selectedDealership == null){
           return 'Organization Grade';
        }
        else{
           return 'Dealership Grade';
        }
      },

      isAdmin(){
         return (this.$auth.profile.acct_type === 'AGENCY' && this.$auth.profile.user_role === 'Admin' )
      }

   },

  async created(){

      this.orgs = await this.get_organizations();


      if (this.orgs.length>0){
         this.selected_org_id = this.orgs[0]._id;
      }
     await this.on_org_change();



     // await this.get_dealers_local();

     // if (this.dealerships[0]){
     //    this.selectedDealership = this.dealerships[0]._id;
     //    await this.on_select_dealership();
     // }

     if (this.sp_mode){
        this.selectedSalesPerson = this.$auth.profile;
        this.selectedDealership = this.dealerships[0]._id;
        await this.get_graded_leads_local(this.$auth.profile.user_id);
     }


  }
};
</script>
